import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./MonthlyMegaQuiz.module.css";
import { quiz_date, check_user } from "../../http/http";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MonthlyMegaQuiz = ({ click }) => {
  const msisdn = useSelector((s) => s.persisted.msisdn);
  const { t } = useTranslation();
  const nev = useNavigate();

  const [quizDate, setQuizDate] = useState(null);
  const [loading, setLoading] = useState(true);

  const [timeLeft, setTimeLeft] = useState({
    days: "00",
    hours: "00",
    mins: "00",
    secs: "00",
  });

  const [showRegister, setShowRegister] = useState(true);
  const [showRegister2, setShowRegister2] = useState(true);
  const [completion_status, setcompletion_status] = useState("");

  useEffect(() => {
    fetchQuizDate();
  }, []);

  useEffect(() => {
    if (!quizDate) return;

    const interval = setInterval(() => {
      const now = new Date();
      const startTime = new Date(quizDate.start_time);

      const diff = startTime - now;

      if (diff <= 0) {
        setTimeLeft({
          days: "00",
          hours: "00",
          mins: "00",
          secs: "00",
        });

        setShowRegister(false);
        console.log();

        clearInterval(interval);
        return;
      }

      setShowRegister(true);

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));

      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );

      const mins = Math.floor(
        (diff % (1000 * 60 * 60)) / (1000 * 60)
      );

      const secs = Math.floor(
        (diff % (1000 * 60)) / 1000
      );

      setTimeLeft({
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        mins: String(mins).padStart(2, "0"),
        secs: String(secs).padStart(2, "0"),
      });
    }, 1000);

    console.log(showRegister);


    return () => clearInterval(interval);
  }, [quizDate]);

  const fetchQuizDate = async () => {
    try {
      setLoading(true);

      const response = await quiz_date();
      if (msisdn?.msisdn) {
        const response1 = await check_user(msisdn?.msisdn);
        setShowRegister2(!response1?.exists || false);
        setcompletion_status(response1?.data?.completion_status || "");
      }


      // console.log(response1);



      if (response?.success && response?.data) {
        setQuizDate(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch quiz date", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={styles.card}>
        <div className={styles.loaderContainer}>
          <div className={styles.loader}></div>
          <p className={styles.loadingText}>Loading Quiz...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <div className={styles.circle}></div>
      <div className={styles.liveStatus}>Live</div>

      <h1 className={styles.title}>{t('127')}</h1>

      <p className={styles.subtitle}>
                {t("128")}
      </p>

      <div className={styles.timer}>
        <div className={styles.timeBlock}>
          <span className={styles.number}>{timeLeft.days}</span>
          <span className={styles.label}>{t("129")}</span>
        </div>

        <span className={styles.separator}>:</span>

        <div className={styles.timeBlock}>
          <span className={styles.number}>{timeLeft.hours}</span>
          <span className={styles.label}>{t("130")}</span>
        </div>

        <span className={styles.separator}>:</span>

        <div className={styles.timeBlock}>
          <span className={styles.number}>{timeLeft.mins}</span>
          <span className={styles.label}>{t("131")}</span>
        </div>

        <span className={styles.separator}>:</span>

        <div className={styles.timeBlock}>
          <span className={styles.number}>{timeLeft.secs}</span>
          <span className={styles.label}>{t("132")}</span>
        </div>
      </div>

      {showRegister && showRegister2 && (
        <button
          className={styles.register}
          onClick={() => click(true)}
        >
          Register Now
        </button>
      )}

      {!showRegister2 && (
        <button
          className={styles.register}
          onClick={() => {
            if (!showRegister && completion_status !== "completed") {
              nev("/megaquiz", {
                state: {
                  quizDate,
                },
              });
            }
          }}
        >
          {showRegister
            ? t("133")
            : completion_status === "completed"
              ? t("134")
              : t("135")}
        </button>
      )}
    </div>
  );
};

export default MonthlyMegaQuiz;